import React, { ReactNode, useState } from 'react';

import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@material-ui/icons/KeyboardArrowUpOutlined';

import styles from './MoreFiltersSection.module.scss';

export interface MoreFiltersSectionProps {
  count: number;
  children: ReactNode;
}

const MoreFiltersSection = ({ count, children }: MoreFiltersSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.container} data-testid="job-search-more-filters-section">
      <button
        type="button"
        className={styles.header}
        onClick={() => setIsOpen(open => !open)}
        aria-expanded={isOpen}
        data-testid="job-search-more-filters-toggle"
      >
        <span className={styles.header_text}>More filters ({count})</span>
        <span className={styles.header_icon}>
          {isOpen ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
        </span>
      </button>

      {isOpen && <div className={styles.body}>{children}</div>}
    </div>
  );
};

export default MoreFiltersSection;
